import { render, staticRenderFns } from "./ModalSendSucess.vue?vue&type=template&id=13ac7ff5&scoped=true&"
import script from "./ModalSendSucess.vue?vue&type=script&lang=js&"
export * from "./ModalSendSucess.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendSucess.vue?vue&type=style&index=0&id=13ac7ff5&prod&lang=css&"
import style1 from "./ModalSendSucess.vue?vue&type=style&index=1&id=13ac7ff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac7ff5",
  null
  
)

export default component.exports